import React from 'react';
import MeetingGrid from '../../../shared/classroom-ui/MeetingGrid.jsx';
import StudentMeetingCard from './StudentMeetingCard';

const MeetingLayout = ({
    attendees,
    tutorStream,
    meetingStarted,
    handleTutorAudio,
    handleTutorCam,
    handleStudentAudio,
    handleStudentCam,
}) => {
    const participants = Array.isArray(attendees) ? attendees : [];
    return (
        <MeetingGrid active={meetingStarted} count={participants.length}>
            {(layout) => participants.map((attendee) => (
                <StudentMeetingCard
                    key={`${attendee.user_id}-${attendee.socket_id}`}
                    cardDimensions={layout}
                    attendee={attendee}
                    toturStream={tutorStream}
                    handleStreamTutorAudio={handleTutorAudio}
                    handleStreamTutorCam={handleTutorCam}
                    handleStreamStudentAudio={handleStudentAudio}
                    handleStreamStudentCam={handleStudentCam}
                />
            ))}
        </MeetingGrid>
    );
};

export default MeetingLayout;
